import React from 'react';
import { Module, SurveyType } from 'shared/prisma/types';
import { CollectionActivityAlerts } from 'components/CollectionActivityStatus';
import SurveysCard from '../Survey/SurveysCard';

const CX = ({
  dataSourceId,
  collectionActivity,
  activeLicense,
  dataSourceType,
  notCollecting,
  isDemo,
  isTest,
}) => (
  <>
    {notCollecting && !isDemo && !isTest && (
      <CollectionActivityAlerts
        collectionActivity={collectionActivity}
        activeLicense={activeLicense}
        dataSourceType={dataSourceType}
        dataSourceId={dataSourceId}
      />
    )}
    <SurveysCard module={Module.CxSurveys} types={[SurveyType.Cx]} />
  </>
);

export default CX;
